<!-- 自定义表单组件 -->
<template>
  <div class='custom-form-item' :class="[arrangement==='flex' && 'flex align-items-center', underLine ? 'under_line' : '']">
    <div class="left" v-if="showName"><span :class="need ? '' : 'visible_hide'">*</span>{{name}}</div>
    <div class="right flex-grow-1">
      <div v-if="!isMobile">
        <input :name="placeholder" :type="type" :disabled="disabled" :placeholder="placeholder" :value="value" :maxlength='maxlength' @input="onInput" @blur="blur">
        <div class="arrow flex align-items-center" @click="onRightIcon">
          <slot v-if="icon"></slot>
          <img src="@/assets/imgs/icon/arrow-right.png" alt="" v-if="placeholder.includes('请选择')">
        </div>
      </div>
      <div v-else class="flex align-items-center">
        <!-- <input name="区号" placeholder="区号" type="tel" maxlength="4" class="mobile-right" :value="mobileL" @change="changeMobileLeft">
        <span>-</span> -->
        <input name="电话" placeholder="电话" type="tel" maxlength="8" class="mobile-left" :value="mobileR" @change="changeMobileRight">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomFormItem',

  data () {
    return {
    };
  },

  props: {
    arrangement: {
      type: String,
      default: 'flex'
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: "请输入"
    },
    name: {
      type: String,
      default: "名称"
    },
    icon: { //是否自定义右边icon
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [String, Number],
      default: ''
    },
    showName: {
      type: Boolean,
      default: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    mobileL: {
      type: [String, Number],
      default: ""
    },
    mobileR: {
      type: [String, Number],
      default: ""
    },
    underLine: {
      type: Boolean,
      default: false
    },
    need: {
      type: Boolean,
      default: false
    }
  },

  created() {},

  methods: {
    onInput(e) {
      this.$emit("input", e.target.value)
    },
    onRightIcon() {
      this.$emit("onRightIcon")
    },
    blur() {
      this.$emit('blur')
    },
    changeMobileRight(e) {
      this.$emit('mobileRight', e.target.value)
    },
    changeMobileLeft(e) {
      this.$emit('mobileLeft', e.target.value)
    }
  },
}

</script>

<style lang='less' scoped>
  .custom-form-item {
    .left {
      font-size: 14px;
      // font-weight: bold;
      margin-left: 14px;
      padding: 10px 0;
      min-width: 68px;
      span {
        color: red;
      }
    }
    .right {
      font-weight: 500;
      padding: 10px 0;
      position: relative;
      input {
        width: 100%;
        box-sizing: border-box;
        line-height: 20px;
        padding: 0 34px 0 20px;
        // background:rgba(246,246,246,1);
        // border-radius:22px;
      }
      .arrow {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }
      .mobile-right {
        width: 100px;
      }
    }
  }

  .under_line {
    border-bottom: 1px solid #EEEEEE;
  }

  .visible_hide {
    visibility: hidden;
  }
</style>